import type { Dictionary } from './types';

export const ko: Dictionary = {
  page_title: 'AI-DLC 프레임워크',
  page_subtitle: 'NxKMS — AgentSkills Hub — 프로젝트 배포 흐름',

  la_badge: '레이어 A',
  la_sub: '기업 지식 관리 시스템 — 모든 지식 소스를 Knowledge Node로 표준화',
  la_src_label: '지식 입력 소스',
  la_s1_t: '파일 업로드', la_s1_d: '프로젝트 Docs/PDF/MD',
  la_s2_t: 'Google Drive', la_s2_d: '폴더별 자동 동기화',
  la_s3_t: 'Notion / Slack', la_s3_d: '내부 문서 & 토론',
  la_s4_t: 'Repo / Wiki', la_s4_d: 'CLAUDE.md, AGENTS.md',
  la_flow_label: '내부 처리 흐름 — 팀 상호작용',
  la_f1: '업로드 & 수집', la_f2: 'Knowledge Node로 표준화',
  la_f3: '시맨틱 인덱싱', la_f4: '도메인 태깅',
  la_f5: '시맨틱 검색', la_f6: '프로젝트 상담 → Skills 추천',
  la_f7: 'AgentSkills Hub로 연결',
  la_m1_t: 'Knowledge Repository',
  la_m1_d: '파일 & Drive 콘텐츠 통합 — 도메인별 Knowledge Node로 표준화',
  la_m2_t: 'Project Advisor',
  la_m2_d: '프로젝트 킥오프 시 tech stack/도메인에 맞는 Skills 추천',
  la_uflow_label: '사용자 플로우 — 관리자가 설정하고 프로젝트 멤버가 대화',
  la_uflow_admin_t: '관리자 측',
  la_uflow_user_t: '프로젝트 멤버 측',
  la_uflow_admin_steps: [
    '지식 소스 업로드',
    '프로젝트 / 도메인별 태그',
    '챗봇 생성 (일반 또는 지식 특화)',
    '내부 배포',
  ],
  la_uflow_user_steps: [
    'NxKMS 포털 열기',
    '프로젝트 챗봇 선택',
    '자연어로 질문',
    '출처 포함 답변 수신',
  ],
  la_ui_demo_label: '미리보기 — 프로젝트 챗봇 인터페이스',
  la_ui_sidebar_t: '프로젝트 챗봇',
  la_ui_bots: [
    { name: 'Fintech Payment Bot', desc: 'PCI-DSS 도메인 전문가', active: true },
    { name: 'Legacy Migration Bot', desc: 'COBOL → Java 컨텍스트' },
    { name: 'NTQ 범용 어시스턴트', desc: '전사 Q&A' },
    { name: 'Monitoring / SRE Bot', desc: 'onTune, Beyla, Prometheus' },
  ],
  la_ui_user_msg: '일본 고객을 위한 3DS 챌린지 실패는 결제 플로우에서 어떻게 처리되나요?',
  la_ui_bot_msg: 'PRD-023-payment.md 및 SBPayment 통합 명세에 따르면 3DS 실패는 재시도 큐를 통해 2회까지 시도됩니다. 일본 고객은 Fintech 규정 정책에 따라 fraud-review 플래그도 함께 트리거됩니다.',
  la_ui_sources_t: '출처',
  la_ui_sources: ['PRD-023-payment.md', 'sbpayment-integration.md', 'fintech-rules.md'],
  la_ui_input_ph: '이 프로젝트에 대해 질문...',

  conn_ab_dn: '프로젝트 컨텍스트에 맞는 Skills 추천',
  conn_ab_up: '검증된 Skills → Knowledge Base 확장',
  conn_ab_dn_note: 'NxKMS가 프로젝트 도메인을 분석해 최적 Skills를 자동 추천 — 프로젝트 킥오프 시 트리거.',
  conn_ab_up_note: '검토 및 배포된 Skills는 도메인 태그와 함께 NxKMS에 추가 — 이후 프로젝트의 검색 정확도 향상.',

  lb_badge: '레이어 B',
  lb_sub: 'AI Skills 집계 · 관리 · 배포 플랫폼 — 모든 NTQ 프로젝트 대상',
  lb_official_t: 'Official Skills — 메이커 검증',
  lb_official_d: '기술을 구축하는 기업의 공식 Skills — NTQ팀이 검증 후 동기화',
  lb_see_more: '40+ 크리에이터 표시',
  lb_see_less: '숨기기',
  lb_ntq_t: 'NTQ 커스텀 Skills',
  lb_ntq_d: 'Tech stack/도메인/롤별 — NTQ Cloud 팀 구축 & 유지보수',
  lb_pkg_t: '특수 프로젝트용 Skills 패키지',
  pkg1_t: 'Fintech 패키지', pkg2_t: '레거시 마이그레이션', pkg3_t: 'Monitoring / SRE', pkg4_t: 'ISO 27001 / SOC2',
  lb_gov_label: '거버넌스 & 스킬 품질',
  lb_gov_steps: ['Skill Author 작성', '리뷰어 검토', 'Approve & 버전', 'Hub에 배포', 'Usage analytics'],
  lb_flow_label: 'Hub 내 팀 상호작용 흐름',
  lb_f1: '도메인/롤별 Skill 검색', lb_f2: 'CLI로 설치', lb_f3: 'CLAUDE.md 업데이트',
  lb_f4: 'Admin: 정책 관리', lb_f5: '도입률 추적', lb_f6: '프로젝트에서 신규 Skill 제안',
  lb_persona_label: '페르소나',
  lb_p1: 'Skill Author — BA / Architect / 시니어 Dev',
  lb_p2: 'Skill Consumer — Dev / QA / PM',
  lb_p3: 'Reviewer / Team Lead',
  lb_p4: 'Enterprise Admin',
  lb_uflow_label: '사용자 플로우 — 탐색부터 IDE 설치까지',
  lb_uflow_steps: [
    '기술 / 도메인 / 역할로 검색',
    '스킬 상세 미리보기',
    'CLI (skills.sh)로 설치',
    '.claude/skills를 repo에 커밋',
    '팀 전체가 pull & 사용',
  ],
  lb_ui_demo_label: '미리보기 — 스킬 마켓플레이스',
  lb_ui_search_ph: '스킬 검색...',
  lb_ui_filter_label: '필터',
  lb_ui_filter_chips: ['Fintech', 'Java Spring', 'Vue / React', '보안', 'Monitoring'],
  lb_ui_cards: [
    { name: 'fintech-payment', tag: 'NTQ · Domain', desc: '감사 로그 패턴 포함 PCI-DSS 대응 결제 핸들러', downloads: '1.2k 설치' },
    { name: 'spring-boot-3', tag: 'Official · Java', desc: 'Spring Boot 3.x 규칙: Security, JPA, 에러 핸들러', downloads: '3.4k 설치' },
    { name: 'pr-checklist', tag: 'NTQ · Review', desc: '머지 전 셀프 리뷰 체크리스트 + 아키텍처 스멜 감지', downloads: '5.8k 설치' },
    { name: 'playwright-e2e', tag: 'Official · Testing', desc: 'Fixtures & 재시도 로직 포함 Playwright 테스트 생성기', downloads: '2.7k 설치' },
  ],
  lb_ui_install_t: '설치',
  lb_ui_install_hint: '이 명령어를 복사해 프로젝트에 설치',

  conn_bc_dn: '프로젝트 agent/IDE에 Skills 설치',
  conn_bc_up: '실제 프로젝트에서 승화한 Skills 기여',
  conn_bc_dn_note: 'Tech Lead가 Hub에서 Skills 선택 후 .claude/skills/에 설치 — git clone으로 전체 팀 공유.',
  conn_bc_up_note: 'Dev/BA가 프로젝트 중 새로운 베스트 프랙티스 발견 — Skill로 패키지화 — Hub에 제출하여 전체 재사용.',

  lc_badge: '레이어 C',
  lc_title: 'Project Deployment — AI-DLC In Practice',
  lc_sub: 'AI-DLC 프레임워크에 따른 실제 프로젝트 운영 — 모든 프로젝트가 지속적 개선 루프',
  lc_steps_label: '10단계 배포 — 단계를 클릭하여 deck 내용 확인',
  lc_steps: ['Knowledge Foundation', 'Project Structure', 'IDE Mapping', 'Bootstrap', 'Daily Dev Loop', 'Testing', 'Team Standards', 'Security', 'I/O Map', 'Continuous Improvement'],
  lc_steps_th: ['단계', '이름', '담당자', 'AI 역할', '산출물'],
  lc_steps_data: [
    ['S1', 'Knowledge Foundation', 'Tech Lead / BA', '원시 문서를 Markdown으로 표준화; CLAUDE.md/AGENTS.md 초안 작성; docs/context 구축으로 AI 출력 품질 = 지식 품질 실현', 'CLAUDE.md, AGENTS.md, docs/ 폴더'],
    ['S2', 'Project Structure', 'Tech Lead', '.claude/ 트리(rules, skills, commands), docs/ 구조, 명명 규칙, 공유 skills/workflows 레지스트리 정의', '.claude/, docs/requirements, docs/architecture committed'],
    ['S3', 'IDE Mapping', 'Dev Team', 'Claude Code · Cursor · Windsurf에서 동일 개념 매핑(rules, commands, hooks, MCP); 팀 단위 IDE 통일', 'settings.json, .cursor/rules/, .windsurfrules'],
    ['S4', 'Bootstrap', 'Tech Lead + AI', 'AI가 /init으로 코드베이스 스캔 → CLAUDE.md/AGENTS.md 초안; 베이스 Skills 설치 & 커스터마이즈; /feature /fix /review commands 정의', 'CLAUDE.md v1, .claude/skills, .claude/commands'],
    ['S5', 'Daily Dev Loop', 'PM/BA · Dev · AI · CI', '티켓 → /onboard → task file → /feature(plan + TDD + hooks) → 자체 리뷰 → human diff review → CI → PR ready; specs/coding/질문/review/debug/planning 서브 플로우', 'Task file log, code + tests, PR ready'],
    ['S6', 'Testing', 'QA / Dev', '세 가지 흐름: Unit Test(/test), E2E Playwright(/e2e), Requirement-first(/test-plan — PRD acceptance criteria 기반)', 'Test plan, .test.ts, .spec.ts, coverage report'],
    ['S7', 'Team Standards', 'Tech Lead / Reviewer', '4계층: Source of truth · Gold-standard examples · Hooks+CI enforcement · Skill/Docs PR process — "3인 3스타일" 제거', 'team-ai-standards/, gold-standard/, Output Consistency Checklist'],
    ['S8', 'Security', 'Security Lead / Dev', '6개 방어 계층(아키텍처 · git · settings.json permissions · hooks · CI · rules); rules/security.md로 process.env 강제 + sk-/api_key/password 자체 스캔', '.gitignore, deny rules, gitleaks CI, security-hook.sh'],
    ['S9', 'I/O Map', 'BA / Tech Lead', '단계별 Human Input · AI 작업 · Human Gate · Output 표(Knowledge Foundation → Bootstrap → Intake → Design → Implement → Test → Deploy → Improve)', 'I/O diagram(Markdown), API contract'],
    ['S10', 'Continuous Improvement', '전체 롤', '정기 스케줄 없음 — 이벤트 기반: AI가 같은 실수 반복, 같은 context 반복 설명, 더 나은 패턴 발견, 새 도구, 인시던트 — skill/rule 즉시 업데이트', '업데이트된 CLAUDE.md, Hub에 신규 skills, NxKMS에 docs'],
  ],
  lc_flow_label: '프로젝트 내 팀 상호작용 흐름',
  lc_f1: 'Hub에서 Skill 검색', lc_f2: 'IDE 설치 & 설정', lc_f3: 'AI agent 실행', lc_f4: 'Dev / QA 리뷰',
  lc_f5: 'NxKMS 참조', lc_f6: 'Skill 수정 & 반복', lc_f7: 'Hub에 Skill 기여',
  lc_m1_t: '운영 중',
  lc_m1_d: '새로운 패턴 발견 — Skill 초안 — Hub에 리뷰 제출',
  lc_m2_t: '프로젝트 완료 후',
  lc_m2_d: '레트로스펙티브 — 교훈 정리 — Skill 또는 Knowledge Node로 패키지화',
  lc_contrib: '모든 롤(Dev, BA, QA, PM)이 AgentSkills Hub에 Skills를, NxKMS에 문서를 기여할 수 있음 — NTQ 전체의 지속적 개선 루프 형성',

  leg_a: 'NxKMS (지식)', leg_b: 'AgentSkills Hub (Skills)', leg_c: 'Project Layer (실행)', leg_flow: '다운스트림 흐름',

  ntq_cat_tech: '기술 스택별',
  ntq_cat_domain: '프로젝트 도메인별',
  ntq_cat_role: '롤별',
  ntq_tags_tech: [
    { t: 'AWS / Azure', s: 'IaC, Lambda, AKS' },
    { t: 'Java Spring', s: 'Boot 3.x, Security' },
    { t: 'Vue / React', s: 'Vue 3, Next.js 14' },
    { t: 'Go backend', s: 'Gin, gRPC, Ent' },
    { t: 'C# .NET', s: 'Core 8, EF' },
    { t: 'Node.js', s: 'Express, Fastify' },
    { t: 'Python', s: 'FastAPI, Django' },
    { t: 'Mobile', s: 'Flutter, Expo' },
  ],
  ntq_tags_domain: [
    { t: '핀테크', s: 'PCI-DSS, 결제' },
    { t: '헬스케어', s: 'HIPAA, EHR' },
    { t: '이커머스', s: 'Shopify, Cart' },
    { t: '레거시 마이그', s: 'COBOL → Java' },
    { t: '모니터링/SRE', s: 'onTune, Beyla' },
    { t: '에듀테크', s: 'LMS, KT' },
    { t: 'JP 기업', s: 'SBPayment, Bajie' },
    { t: 'KR 기업', s: 'onTune, WhaTap' },
  ],
  ntq_tags_role: [
    { t: 'BA', s: '요구사항, 명세' },
    { t: 'PM / PO', s: '로드맵' },
    { t: 'Dev', s: '코드, 리뷰' },
    { t: 'QA', s: 'Playwright, 테스트' },
    { t: 'DevOps', s: 'CI/CD, IaC' },
    { t: 'Security Lead', s: 'OWASP, 감사' },
    { t: 'Tech Lead', s: '아키텍처' },
    { t: 'Designer', s: 'Figma, hand-off' },
  ],

  access_title: '프로젝트 팀의 접근 방법',
  access_desc: '팀원은 <span class="access-pill access-pill-a">NxKMS</span>에서 지식을 검색하고 Skills 추천을 받거나, <span class="access-pill access-pill-b">AgentSkills Hub</span>에 직접 접근해 Skills를 검색·설치·관리할 수 있음 — 두 경로 모두 동일한 에코시스템으로 통합됨.',
  access_or: '또는',
  access_path_a_label: 'NxKMS',
  access_path_a_desc: '엔터프라이즈 지식을 검색하고 프로젝트에 맞는 AI Skills 추천 받기',
  access_path_a_badge: '지식 경로',
  access_path_b_label: 'AgentSkills Hub',
  access_path_b_desc: 'IDE & 프로젝트를 위한 AI Skills 직접 검색·설치·관리',
  access_path_b_badge: '스킬 경로',
  access_note: '두 경로 모두 하나의 통합 생태계로 수렴됩니다.',

  footer_copy: '© 2026 NTQ Solution JSC — AI-DLC Framework. All rights reserved.',
  footer_version: 'v1.0',

  step_panel_prev: '‹ 이전 단계',
  step_panel_next: '다음 단계 ›',
  step_panel_close: '닫기 ✕',
  step_panel_open_hint: '위의 단계를 클릭하여 deck 내용을 확인하세요',

  deck: {
    s0_title: 'AI-DLC In Practice',
    s0_sub: '프로젝트에서 실제로 어떻게 동작하는가 — 단계별',
    s0_msg: '"AI-DLC는 코드에서 시작하지 않습니다. 지식을 문서로 표준화하는 것에서 시작합니다. 그 외 모든 것은 그 기반에 의존합니다."',

    s1_title: 'Knowledge Foundation',
    s1_sub: '가장 중요한 단계 — 자주 건너뜀',
    s1_msg: 'AI 출력 품질 = 제공되는 지식의 품질',
    s1_col1_t: '원시 지식',
    s1_col2_t: '표준화 →',
    s1_col3_t: 'AI 준비 입력',
    s1_col1: [
      '문서 없는 코드베이스',
      'Wiki, 이메일, 회의록',
      '사람 머릿속에만 있는 기술적 결정',
      'PM만 아는 비즈니스 규칙',
    ],
    s1_col2: [
      '모든 내용 → Markdown (.md)',
      '명확한 헤더 계층 H1→H2→H3',
      'Mermaid로 다이어그램 작성(버전 관리 가능)',
      '의미 있는 이름: PRD-001-auth.md',
    ],
    s1_col3: [
      'CLAUDE.md / AGENTS.md < 200줄',
      'rules/ 관심사별 분리',
      'skills/ — 온디맨드 모듈',
      'docs/context/ — AI 전용 컨텍스트',
    ],

    s1b_title: 'Knowledge Foundation: 도구',
    s1b_sub: '지식 추출을 빠르고 안정적으로 만드는 권장 도구',
    s1b_groups: [
      {
        title: 'Knowledge Graph — 코드 시각화 및 인터랙티브 탐색',
        color: '#4F46E5',
        tools: [
          {
            name: 'GitNexus',
            tag: 'Zero-server · 브라우저 네이티브 Knowledge Graph  ⚠ 커스텀 파서 필요',
            desc: 'GitHub 레포 또는 ZIP을 드롭하면 GitNexus가 브라우저 내에서 인터랙티브한 knowledge graph를 생성. 코드 Q&A를 위한 Graph RAG 에이전트 내장. 미지원 언어 (COBOL, Delphi, 커스텀 DSL)는 사전에 커스텀 tree-sitter 파서 작성 필요.',
            usage: '새 프로젝트 시작 전 사용. 미지원 언어/라이브러리는 커스텀 파서 작성.',
            url: 'github.com/abhigyanpatwari/GitNexus',
            color: '#4F46E5',
          },
          {
            name: 'Understand-Anything',
            tag: 'Claude Code Skill · 인터랙티브 Codebase Knowledge Graph',
            desc: '어떤 코드베이스도 인터랙티브한 knowledge graph로 변환하는 Claude Code / Codex 스킬. 멀티플랫폼 지원. 코드 관계 및 콜 체인 검색·탐색·질문 가능.',
            usage: 'Claude Code에서 /understand-anything 명령어로 실시간 코드베이스 탐색.',
            url: 'github.com/Lum1104/Understand-Anything',
            color: '#0B8A75',
          },
          {
            name: 'Repomix',
            tag: 'CLI · 전체 레포를 AI 가독 단일 파일로 패키징',
            desc: '전체 코드베이스를 LLM 컨텍스트 윈도우에 최적화된 단일 Markdown/XML 파일로 패키징. .repomixignore, 보안 필터링, 토큰 카운팅 지원. 프로젝트 전체 컨텍스트를 한 번에 AI에 전달하는 데 이상적.',
            usage: '전체 코드베이스 인식이 필요한 AI 세션 전에 실행. 생성 파일은 .repomixignore로 제외.',
            url: 'github.com/yamadashy/repomix',
            color: '#E6522C',
          },
          {
            name: 'code2prompt',
            tag: 'CLI · 소스 → 전체 컨텍스트 포함 구조화 프롬프트',
            desc: '소스 코드 파일을 구문 강조, 트리 뷰, 파일 메타데이터가 포함된 구조화 프롬프트로 변환. glob 패턴으로 파일 선택 지원. AI 채팅 복붙이나 CLAUDE.md 주입에 최적화된 출력.',
            usage: '선택된 모듈에서 집중된 프롬프트 생성 시 사용. /feature와 조합해 AI에 정확한 컨텍스트 제공.',
            url: 'github.com/mufeedvh/code2prompt',
            color: '#F59E0B',
          },
        ],
      },
      {
        title: '포맷 변환 — 다양한 문서를 AI 가독 Markdown으로 변환',
        color: '#0078D4',
        tools: [
          {
            name: 'MarkItDown (커스터마이즈)',
            tag: 'Microsoft · PDF / DOCX / PPTX / Web → Markdown  ⚠ 프로젝트별 커스터마이즈 필수',
            desc: '프로젝트마다 커스터마이즈 필요 — 각 프로젝트마다 형식·섹션 구조·명명 규칙이 다름. 일본어 프로젝트는 인코딩 처리 (Shift-JIS/UTF-8), 후리가나 제거, 커스텀 헤딩 재매핑 필요. 어댑터 없이는 Markdown 출력이 AI를 오도할 수 있음.',
            usage: '프로젝트 어댑터 (convert_docs.py) 작성. 대표 샘플 3~5개로 먼저 테스트.',
            url: 'github.com/microsoft/markitdown',
            color: '#0078D4',
          },
          {
            name: 'Docling',
            tag: 'IBM · PDF / DOCX / HTML → 구조화 Markdown + JSON',
            desc: '네이티브 테이블 추출·도형 감지·문서 구조 보존을 갖춘 IBM 오픈소스 파서. Markdown, JSON, Docling Document 형식으로 내보내기. 내장 OCR로 스캔 PDF 처리. 복잡한 레이아웃에서 MarkItDown보다 구조 충실도 우수.',
            usage: '복잡한 표나 그림이 포함된 PDF (계약서, 명세서, 보고서)에 사용. RAG 수집을 위한 청킹 파이프라인과 결합.',
            url: 'github.com/DS4SD/docling',
            color: '#0062A3',
          },
          {
            name: 'Marker',
            tag: 'GPU 가속 · PDF → 고품질 Markdown  ⚠ 속도를 위해 GPU 권장',
            desc: '레이아웃 감지 및 OCR 모델을 사용하는 최신 PDF → Markdown 변환기. 다단 구성, 각주, 수식, 코드 블록 처리. 학술 논문 및 복잡한 일본어/한국어 문서에서 최고 품질. 배치 처리에는 GPU 권장.',
            usage: 'MarkItDown으로 구조가 손실되는 스캔 PDF나 복잡한 문서에 사용. 배치 변환은 GPU 환경에서 로컬 실행.',
            url: 'github.com/VikParuchuri/marker',
            color: '#7C3AED',
          },
          {
            name: 'PyMuPDF4LLM',
            tag: 'PyMuPDF · 페이지 인식 청킹을 통한 빠른 PDF → Markdown',
            desc: 'LLM 최적화 출력으로 빠르고 정확한 PDF 추출을 위해 PyMuPDF 위에 구축된 Python 라이브러리. 페이지별 추출, 헤더 감지, 하이퍼링크 보존 지원. 복잡한 레이아웃 없는 텍스트 중심 PDF에서 Marker보다 훨씬 빠름.',
            usage: '텍스트 중심 문서의 기본 PDF 추출기로 사용. 레이아웃 충실도가 중요할 때만 Marker로 전환.',
            url: 'github.com/pymupdf/PyMuPDF',
            color: '#059669',
          },
        ],
      },
    ],
    s1b_flow: ['소스 (PDF/DOCX/Repo/URL)', '프로젝트별 어댑터 커스터마이즈', '추출 & 변환', '구조화 & 인덱싱', 'docs/context/ 에 커밋'],
    s1b_note: '⚠ 모든 도구는 프로젝트별 커스터마이즈 필요. 포맷 변환 도구는 인코딩/레이아웃 어댑터 필요 (특히 일본어). Knowledge graph 도구는 미지원 언어용 커스텀 파서 필요. 출력을 커밋하기 전에 반드시 실제 샘플 3~5개로 테스트.',

    s2_title: 'Project Structure',
    s2_sub: '.claude/ + docs/ — 모든 파일에 위치와 목적이 있음',
    s2_legend: [
      { type: 'always', label: '항상 로드' },
      { type: 'ondemand', label: '온디맨드' },
      { type: 'manual', label: '수동 트리거' },
      { type: 'hooks', label: '자동 hooks' },
      { type: 'ide', label: 'IDE 전용' },
    ],
    s2_tree: [
      { txt: 'project-root/', type: 'root' },
      { txt: '├── CLAUDE.md', type: 'always', note: '팀 공유 진입점 — 프로젝트 규약, 스택, 필수 사항(< 200줄)' },
      { txt: '├── AGENTS.md', type: 'always', note: 'Cursor/Windsurf 크로스 IDE 호환 변형' },
      { txt: '├── CLAUDE.local.md', type: 'muted', note: '개인 오버라이드(gitignore 처리)' },
      { txt: '├── .claude/', type: 'root' },
      { txt: '│   ├── rules/', type: 'always', note: '항상 켜진 rules — 관심사별 분리(security, style, api)' },
      { txt: '│   ├── skills/', type: 'ondemand', note: '온디맨드 skills(api-handler, unit-test, ...)' },
      { txt: '│   ├── commands/', type: 'manual', note: '/feature /fix /review /deploy — 슬래시 명령' },
      { txt: '│   ├── agents/', type: 'ondemand', note: '전문 흐름용 Sub-agents' },
      { txt: '│   └── settings.json', type: 'hooks', note: 'Hooks(Pre/PostToolUse), 권한, deny rules' },
      { txt: '├── .cursor/rules/', type: 'ide', note: 'Cursor rules 상당물(*.mdc)' },
      { txt: '├── .windsurfrules', type: 'ide', note: 'Windsurf 글로벌 rules' },
      { txt: '├── .mcp.json', type: 'ondemand', note: 'MCP 서버 설정' },
      { txt: '├── docs/', type: 'root', note: '자세한 내용은 다음 슬라이드 참조' },
      { txt: '└── src/ · tests/ · ...', type: 'muted', note: '표준 프로젝트 코드' },
    ],

    s2b_title: 'docs/ 폴더 구조',
    s2b_sub: '심층 분석 — 각 서브폴더를 명명 규칙과 함께 설명',
    s2b_tree: [
      { txt: 'docs/', type: 'root' },
      { txt: '├── requirements/', type: 'always', note: 'PRD 파일 — feature 또는 epic별 하나씩' },
      { txt: '│   ├── PRD-001-user-auth.md', type: 'always', note: '문제 + 목표 + AC + 범위 외' },
      { txt: '│   └── PRD-002-payments.md', type: 'always', note: '명명: PRD-[번호]-[짧은-이름].md' },
      { txt: '├── architecture/', type: 'root' },
      { txt: '│   ├── decisions/', type: 'always', note: 'ADRs — 승인 후 불변' },
      { txt: '│   │   ├── ADR-001-auth-strategy.md', type: 'always', note: '배경 + 결정 + 대안 + 결과' },
      { txt: '│   │   └── ADR-002-database.md', type: 'always', note: '명명: ADR-[번호]-[주제].md' },
      { txt: '│   ├── api-contracts/', type: 'ondemand', note: '도메인별 API 스키마' },
      { txt: '│   │   └── auth.md', type: 'ondemand', note: 'API 엔드포인트 변경 시 업데이트' },
      { txt: '│   └── system-overview.md', type: 'always', note: 'Mermaid 다이어그램 포함 고수준 아키텍처' },
      { txt: '├── tasks/', type: 'root' },
      { txt: '│   ├── active/', type: 'manual', note: '현재 스프린트 — AI가 여기에 세션 로그 기록' },
      { txt: '│   │   └── TASK-101.md', type: 'manual', note: '목표 + AC + 컨텍스트 + 테스트 시나리오' },
      { txt: '│   └── done/', type: 'muted', note: '완료 — 머지 후 이동' },
      { txt: '├── context/', type: 'ondemand', note: 'AI 전용 장기 지식' },
      { txt: '│   ├── domain-glossary.md', type: 'ondemand', note: '비즈니스 용어 — AI 할루시네이션 방지' },
      { txt: '│   ├── known-issues.md', type: 'ondemand', note: '현재 버그 및 해결책' },
      { txt: '│   ├── business-rules.md', type: 'ondemand', note: 'PM/BA만 아는 규칙' },
      { txt: '│   └── tool-changelog.md', type: 'ondemand', note: '팀이 새로운 접근 방식 채택 시' },
      { txt: '└── templates/', type: 'manual', note: '새 파일용 복사-붙여넣기 스타터' },
    ],

    s2c_title: '필수 Skills & Workflows',
    s2c_sub: 'Sprint 1 전에 정의 — 팀의 AI 운영 체제',
    s2c_skills_t: 'Skill 카테고리(AI가 전문화할 수 있는 내용)',
    s2c_workflows_t: '핵심 슬래시 명령(매일 사용)',
    s2c_skills: [
      { cat: '기반 (먼저 설치)', items: ['find-skills', 'skill-creator', 'context-builder'], color: 'teal' },
      { cat: 'Coding', items: ['api-handler', 'component', 'service', 'database'], color: 'accent' },
      { cat: 'Testing', items: ['unit-test', 'e2e-playwright', 'test-plan'], color: 'teal' },
      { cat: 'Review', items: ['pr-checklist', 'code-review'], color: 'amber' },
      { cat: 'Infrastructure', items: ['security', 'docker', 'ci-cd'], color: 'purple' },
    ],
    s2c_workflows: [
      { cmd: '/find-skills [주제]', desc: '사용 가능한 스킬 검색 및 발견' },
      { cmd: '/create-skill [이름]', desc: '템플릿에서 새 스킬 생성' },
      { cmd: '/feature TASK-xxx', desc: '완전한 TDD 구현 흐름' },
      { cmd: '/fix TASK-xxx', desc: '리그레션 테스트 포함 버그 수정' },
      { cmd: '/review', desc: 'PR 자체 리뷰 체크리스트' },
      { cmd: '/deploy [env]', desc: '프리플라이트 게이트 포함 배포' },
      { cmd: '/test [file]', desc: '유닛 테스트 생성' },
      { cmd: '/test-plan PRD-xxx', desc: '스펙 우선 테스트 계획' },
      { cmd: '/onboard TASK-xxx', desc: '티켓에서 태스크 수집' },
      { cmd: '/e2e [scenario]', desc: 'E2E Playwright 테스트' },
      { cmd: '/init', desc: '프로젝트 부트스트랩 스캔' },
      { cmd: '/refactor [scope]', desc: '안전한 리팩터링 워크플로우' },
    ],

    s3_title: 'IDE Tool Mapping',
    s3_sub: 'Claude Code · Cursor · Windsurf — 같은 개념, 다른 구문',
    s3_th: ['개념', 'Claude Code', 'Cursor', 'Windsurf'],
    s3_rows: [
      ['Always-on Rules', 'CLAUDE.md\n+ .claude/rules/*.md', '.cursor/rules/*.mdc\n(alwaysApply: true)', '.windsurfrules\nglobal_rules.md'],
      ['Path-scoped Rules', '서브디렉터리\nCLAUDE.md', '*.mdc with\nglob patterns', 'Workspace rules\n(glob mode)'],
      ['On-demand Skills', 'skills/\n(자동 활성화)', 'rules/ with\n@ruleName manual', 'Memories\n(자동 저장/불러오기)'],
      ['Slash Commands', 'commands/*.md', 'rules/ description\nfield', 'Workflows\n/workflow-name'],
      ['Auto Events', 'settings.json\nPre/PostToolUse', 'SKILL.md\nhooks', 'Auto-memory +\nTurbo mode'],
      ['Sub-agents', 'agents/*.md', 'Background\nAgents', 'Parallel\nCascades'],
      ['Cross-IDE', 'AGENTS.md (root)', 'AGENTS.md (root)', 'AGENTS.md (root)'],
      ['MCP', '.mcp.json', '.mcp.json', '.mcp.json'],
    ],

    s4_title: 'Project Bootstrap',
    s4_sub: '일회성 설정 — Sprint 1 전에 완료',
    s4_lanes: ['Tech Lead', 'Dev Team', 'AI Agent', 'Output'],
    s4_steps: [
      { row: 0, lane: 0, text: 'tech stack 정의\nbusiness domain\n코딩 규칙', type: 'io' },
      { row: 0, lane: 2, text: '/init → 코드베이스 스캔\n프레임워크, 패턴\n의존성, 테스트 설정 감지', type: 'step' },
      { row: 1, lane: 3, text: 'CLAUDE.md 초안\nAGENTS.md 초안', type: 'io' },
      { row: 1, lane: 0, text: '초안 리뷰\n비즈니스 컨텍스트 추가\nNEVER-do rules 추가\n< 200줄 유지', type: 'gate' },
      { row: 2, lane: 3, text: 'CLAUDE.md v1 ✓\nAGENTS.md v1 ✓', type: 'note' },
      { row: 2, lane: 0, text: 'skills.sh + 공식 리포에서\n베이스 skills 검색 & 설치\n→ 프로젝트에 맞게 커스터마이즈', type: 'step' },
      { row: 2, lane: 2, text: 'skills 커스터마이즈:\n+ 프로젝트 패턴\n+ Gotchas 섹션\n+ examples/ 폴더', type: 'step' },
      { row: 3, lane: 3, text: '.claude/skills/ ✓\n.cursor/rules/ ✓', type: 'note' },
      { row: 3, lane: 0, text: '명령어 정의:\n/feature /fix\n/review /deploy', type: 'step' },
      { row: 3, lane: 2, text: '명령어 파일 작성\nsettings.json에서\nhooks 설정', type: 'step' },
      { row: 4, lane: 3, text: '.claude/commands/ ✓\nsettings.json ✓', type: 'note' },
      { row: 4, lane: 0, text: '.claude/를 git에 커밋\n전 팀원 클론 → 준비 완료', type: 'gate' },
      { row: 5, lane: 3, text: '전 팀원 준비 완료 ✓', type: 'note' },
    ],

    s5_title: 'Daily Dev Loop',
    s5_sub: '피처 개발 스윔레인 — 매일 반복',
    s5_lanes: ['PM / BA', 'Dev', 'AI Agent', 'CI / CD', 'Output'],
    s5_steps: [
      { row: 0, lane: 0, text: '티켓 #101 생성\n(acceptance criteria 포함)', type: 'io' },
      { row: 0, lane: 1, text: '/onboard TASK-101', type: 'step' },
      { row: 0, lane: 2, text: 'MCP로 티켓 읽기\n관련 파일 스캔\n모호한 점 파악', type: 'step' },
      { row: 1, lane: 2, text: '확인 질문', type: 'step' },
      { row: 1, lane: 0, text: '질문에 답변\n범위 확인', type: 'gate' },
      { row: 1, lane: 3, text: 'CI 워밍업', type: 'note' },
      { row: 2, lane: 2, text: 'TASK-101.md 작성:\n• 목표 + AC\n• 기술 메모\n• 테스트 시나리오', type: 'step' },
      { row: 2, lane: 1, text: 'task file 리뷰 ✓\n/feature TASK-101', type: 'gate' },
      { row: 2, lane: 2, text: 'rules + skills 로드\n→ PLAN MODE:\n접근 방식 제안', type: 'step' },
      { row: 3, lane: 1, text: '계획 승인\n또는 수정', type: 'gate' },
      { row: 3, lane: 2, text: '[HOOK: PreToolUse]\n→ 실패 테스트 작성\n→ 구현\n[HOOK: PostToolUse]', type: 'hooks' },
      { row: 4, lane: 2, text: 'pr-checklist skill로\n자체 리뷰\nTASK-101 로그 업데이트', type: 'step' },
      { row: 4, lane: 1, text: 'diff 리뷰\nAC 수동 테스트\nPR 푸시', type: 'gate' },
      { row: 4, lane: 3, text: 'CI: unit tests\nlint · secret scan\ncoverage check', type: 'step' },
      { row: 4, lane: 4, text: 'Code ✓  Tests ✓\nPR ready ✓', type: 'io' },
    ],

    s5b_title: '효과적인 일일 프롬프트',
    s5b_sub: '최상의 AI 출력을 위해 지시에 포함할 내용',
    s5b_anat_t: '좋은 프롬프트의 구조',
    s5b_examples_t: '실제 예시(복사 & 붙여넣기)',
    s5b_anat: [
      { t: '컨텍스트', d: '무엇을 하고 있나? 관련 파일은?' },
      { t: '타겟 액션', d: 'AI가 정확히 무엇을 해야 하나? (/feature, /refactor)' },
      { t: '제약 조건', d: '무엇을 피해야 하나? 어떤 rules를 따라야 하나?' },
    ],
    s5b_examples: [
      { tag: '피처 구현', body: '/feature TASK-xxx\nPRD-001을 기반으로 UserProfile 컴포넌트를 구현해주세요. 스타일링에는 Tailwind 사용. state를 직접 변경하지 말 것; docs/rules/의 React 성능 표준을 따라주세요.' },
      { tag: '리팩터링', body: '/refactor\n이 파일을 리팩터링하여 데이터 페칭 로직을 커스텀 React hook(useUserProfile)으로 추출하세요. 기존 테스트를 통과한 상태 유지. UI 변경 없음.' },
      { tag: '디버깅', body: '/fix\n토큰 만료 시 API가 401을 반환합니다. auth.ts와 axios interceptors를 확인하세요. ADR-002-auth-strategy.md를 기반으로 자동 토큰 갱신 로직을 추가하세요.' },
    ],

    s5c_title: 'Specs & Brainstorm Flow',
    s5c_sub: '아이디어에서 확정된 요구사항으로 — AI를 사고 파트너로',
    s5c_lanes: ['BA / PM', 'AI Assistant', 'Human Gate'],
    s5c_steps: [
      { lane: 0, row: 0, text: '초기 피처 브리프\n또는 사용자 스토리 작성', type: 'io' },
      { lane: 1, row: 0, text: '브리프 분석 → 의도 명확화\n→ 유스케이스 제안', type: 'step' },
      { lane: 2, row: 0, text: '리뷰어: 초안을\n승인 또는 거부', type: 'gate' },
      { lane: 0, row: 1, text: '도메인 컨텍스트\n+ 타겟 오디언스 + 제약 제공', type: 'step' },
      { lane: 1, row: 1, text: 'acceptance criteria\n+ edge cases + 범위 외 생성', type: 'step' },
      { lane: 2, row: 1, text: 'Tech Lead 리뷰:\nAC 승인 → PRD-xxx.md 확정', type: 'gate' },
      { lane: 0, row: 2, text: 'PRD-xxx.md를\ndocs/requirements/에 커밋', type: 'io' },
      { lane: 1, row: 2, text: 'PRD에서 TASK-xxx.md\n자동 생성', type: 'step' },
      { lane: 2, row: 2, text: '스프린트 준비 완료 ✓\n백로그 업데이트 ✓', type: 'note' },
    ],
    s5c_tips: [
      '프롬프트에 포함: 현재 초안 텍스트 · 타겟 오디언스 · 비즈니스 제약 · AI가 가정해서는 안 되는 것',
      '예시 오프너: "결제 모듈의 PRD 초안입니다. 타겟: B2B 클라이언트. 제약: PCI-DSS 준수 필수. 누락된 요구사항과 edge cases를 찾아주세요."',
      'AI가 가장 잘 하는 것: 모호한 요구사항 발견 · 네거티브 테스트 케이스 제안 · 내러티브에서 AC 초안 · 상충하는 목표 감지',
    ],

    s5d_title: 'Coding Flow',
    s5d_sub: 'Task → Plan → Implement → Review — 가드레일 포함 AI 페어 프로그래밍',
    s5d_lanes: ['Human', 'Plan', 'Implement', 'Verify'],
    s5d_steps: [
      { lane: 0, row: 0, text: '/feature TASK-101\n(task file 로드\n+ 관련 skills)', type: 'step' },
      { lane: 1, row: 0, text: 'AI가 rules/\n+ skills/ 읽기 → 접근 방식 제안', type: 'step' },
      { lane: 0, row: 1, text: '계획 리뷰:\n승인 ✓ 또는 수정 ✗', type: 'gate' },
      { lane: 2, row: 1, text: 'AI가 먼저 실패\n테스트 작성(TDD)', type: 'step' },
      { lane: 2, row: 2, text: 'AI가 테스트를\n통과하는 피처 구현', type: 'step' },
      { lane: 3, row: 2, text: 'Hooks: 자동 포맷\nlint 체크\n→ 실패 시 차단', type: 'hooks' },
      { lane: 0, row: 3, text: 'Human이 diff 리뷰\n+ AC 확인 → PR ready', type: 'gate' },
      { lane: 3, row: 3, text: 'CI: tests + scan\n→ 통과 시 merge', type: 'io' },
    ],
    s5d_tips: [
      '/feature prompt: "TASK-101 구현. docs/rules/react-perf.md 따르기. hooks 사용, class components 불가. 범위 외: payment logic. auth.ts 건드리기 전에 멈추고 확인."',
      '/fix prompt: "버그: 토큰 만료 시 API가 401 반환. 증상: 세션 중 로그인 페이지 출현. 가설: interceptor가 재시도 안 함. 먼저 src/api/interceptors.ts 확인."',
      '/refactor prompt: "UserProfile.tsx에서 데이터 페칭을 useUserProfile hook으로 추출. 모든 기존 테스트 통과 유지. JSX 레이아웃이나 props 인터페이스는 절대 변경하지 말 것."',
    ],

    s5e_title: 'Asking Flow',
    s5e_sub: '코드베이스를 변경하지 않고 이해하기',
    s5e_lanes: ['Developer', 'AI Agent', 'Gate'],
    s5e_steps: [
      { lane: 0, row: 0, text: '컨텍스트 파일 로드:\n@file.ts @ADR-00x.md', type: 'io' },
      { lane: 1, row: 0, text: '범위 확인:\n파일 명확화 필요 여부 확인', type: 'step' },
      { lane: 0, row: 1, text: "질문 제시:\n'X는 어떻게 동작하나?'\n'Y를 바꾸면 무엇이 깨지나?'", type: 'step' },
      { lane: 1, row: 1, text: '코드 흐름을 단계별로 추적\n줄 번호 인용', type: 'step' },
      { lane: 2, row: 1, text: 'Dev가 AI 답변을\n실제 코드와 대조', type: 'gate' },
      { lane: 0, row: 2, text: '틀림: 수정 + 재질문\n맞음: 진행', type: 'step' },
      { lane: 1, row: 2, text: '코드 생성 없음\n— 답변만', type: 'note' },
    ],
    s5e_tips: [
      '모든 탐색 프롬프트에 "코드 변경을 제안하지 말 것" 추가',
      '항상 @file 참조 사용 — AI가 보지 않은 코드에 대해 할루시네이션하는 것 방지',
      '무엇(WHAT)만 묻지 말고 왜(WHY)를 물을 것. "토큰이 쿠키가 아닌 메모리에 저장되는 이유 설명"',
    ],

    s5f_title: 'Reviewing Flow',
    s5f_sub: '휴먼 리뷰어 전 AI 프리 리뷰 — 구조화된 출력',
    s5f_lanes: ['Developer', 'AI Agent', 'Human Reviewer'],
    s5f_steps: [
      { lane: 0, row: 0, text: '변경사항 스테이징:\ngit add -p(선택적)', type: 'io' },
      { lane: 0, row: 1, text: '실행: /review\n@docs/rules/code-style.md\n@docs/rules/security.md', type: 'step' },
      { lane: 1, row: 1, text: '스테이징 diff 분석\nrules + ADRs와 대조', type: 'step' },
      { lane: 1, row: 2, text: '출력:\nBLOCKER(반드시 수정)\nWARNING(고려)\nSUGGESTION(선택)', type: 'step' },
      { lane: 0, row: 2, text: '모든 BLOCKER 수정\n푸시 + PR 오픈', type: 'gate' },
      { lane: 2, row: 3, text: '리뷰:\n비즈니스 로직\n설계 결정', type: 'gate' },
      { lane: 2, row: 3, text: 'Merge ✓ 또는 변경 요청', type: 'io' },
    ],
    s5f_tips: [
      'AI가 체크: 규칙 위반 · 누락된 에러 처리 · 보안 이슈 · 명명/패턴 이탈',
      'Human이 집중: 비즈니스 로직 정확성 · 설계 결정 · 지식 전수 · 새로운 패턴',
      '리뷰 프롬프트: "스테이징 diff 리뷰. 출력: BLOCKER | WARNING | SUGGESTION. Prettier가 처리하는 스타일 이슈는 플래그 불필요."',
    ],

    s5g_title: 'Debugging Flow',
    s5g_sub: '체계적인 버그 조사 — 정밀한 진단을 위한 구조화된 컨텍스트',
    s5g_lanes: ['Developer', 'AI Agent', 'Output'],
    s5g_steps: [
      { lane: 0, row: 0, text: '버그 재현\n수집: 에러 + 스택 트레이스', type: 'io' },
      { lane: 0, row: 1, text: '로드: TASK-xxx.md\n+ 의심 파일 + ADRs', type: 'step' },
      { lane: 0, row: 1, text: '가설 제시\n+ 안전 구역(X 건드리지 말 것)', type: 'step' },
      { lane: 1, row: 2, text: '콜 체인 추적\n근본 원인 파악\n수정 옵션 제안', type: 'step' },
      { lane: 0, row: 2, text: '수정을 수락하기 전에\n진단 검증', type: 'gate' },
      { lane: 1, row: 3, text: '안전 구역 경계 내에서\n수정 구현', type: 'step' },
      { lane: 2, row: 3, text: 'unit tests 실행 ✓\n리그레션 테스트 추가 ✓', type: 'io' },
    ],
    s5g_tips: [
      '버그 컨텍스트: 증상 + 에러 메시지(전체 스택 트레이스) + 재현 단계',
      '가설: 최선의 추측 — 틀린 가설도 AI가 더 빠르게 범위를 좁히는 데 도움',
      '안전 구역: "수정 금지: LoginPage, authSlice.ts" — AI의 과도한 개입 방지',
    ],

    s5h_title: 'Planning Flow',
    s5h_sub: '작업을 작고 검증 가능한 태스크로 분해 — AI 실행을 위한 명확한 입출력',
    s5h_lanes: ['Tech Lead / Dev', 'AI Agent', 'Gate'],
    s5h_steps: [
      { lane: 0, row: 0, text: '로드: PRD-xxx.md\n+ 아키텍처 문서\n+ 기존 태스크', type: 'io' },
      { lane: 0, row: 0, text: "목표 설명:\n'피처 X 구축'\n또는 '모듈 Y 리팩터'", type: 'step' },
      { lane: 1, row: 1, text: '서브태스크로 분해\n각 태스크에:\n- 입력 파일\n- 출력 파일\n- 검증 체크리스트', type: 'step' },
      { lane: 0, row: 1, text: '태스크 계획 리뷰:\n각 태스크가 충분히 작은가?\n(< 1세션)', type: 'gate' },
      { lane: 1, row: 2, text: '각 서브태스크에:\n전체 템플릿으로\nTASK-xxx.md 생성', type: 'step' },
      { lane: 0, row: 2, text: '확인: 각 태스크에\n명확한 AC + 검증 단계가 있는가?', type: 'gate' },
      { lane: 2, row: 3, text: '승인된 계획 →\n순서대로 태스크 실행', type: 'io' },
    ],
    s5h_tips: [
      '크기 규칙: AI가 1세션 이상 필요하면 더 분할. 각 태스크: 1 입력 → 1 출력 → 1 검증 명령',
      '태스크 템플릿: 목표 · 입력 파일 · 출력 파일 · Acceptance Criteria · 검증 명령',
      '의존성 순서: 각 태스크의 출력이 다음 태스크의 입력이 되도록 순서 지정. 순환 의존성 없음.',
    ],

    s6_title: 'Testing Workflow',
    s6_sub: 'Unit test · E2E Playwright · 요구사항 우선 테스트',
    s6_flows: [
      {
        t: 'Flow A: Unit Test',
        steps: [
          'Dev: /test [file]',
          'AI: unit-test skill 로드, functions + error paths 분석',
          'AI: TEST PLAN 생성(코드 없음 — 먼저 리뷰)',
          'Dev: plan 리뷰 ✓, 시나리오 추가/제거',
          'AI: 테스트 작성 & 실행, 실패 시 수정',
          'HOOK: coverage 체크 — 임계값 미달 시 차단',
          'Output: .test.ts ✓  Coverage ✓',
        ],
      },
      {
        t: 'Flow B: E2E Playwright',
        steps: [
          'Dev: /e2e "user checkout"',
          'AI: e2e skill 로드, 스토리 → POM 페이지 매핑',
          'AI: Page Objects 생성, 테스트 시나리오 작성',
          'AI: 헤드리스 실행 — pass/fix 루프',
          'CI: staging 푸시 시 E2E 스위트 실행',
          '실패 시 merge 차단',
          'Output: .spec.ts ✓  CI report ✓',
        ],
      },
      {
        t: 'Flow C: Requirement → Tests',
        steps: [
          'BA: acceptance criteria 포함 PRD-xxx.md 작성',
          'Dev: /test-plan PRD-xxx',
          'AI: AC 추출 → positive + negative + edge 생성',
          'Dev: test plan 리뷰 ✓(모호한 점 발견!)',
          'BA: 모호한 점 명확화',
          'AI: 실패 테스트(stubs) 작성',
          'Dev: 구현 → 테스트 점진적 통과 → 전부 그린 ✓',
        ],
      },
    ],

    s7_title: 'Team Standardisation',
    s7_sub: '모든 개발자가 일관되고 재사용 가능한 출력을 생성하도록 보장',
    s7_problem_t: '깨진 상태',
    s7_problem: [
      'Dev A (Cursor) → 스타일 X',
      'Dev B (Claude Code) → 스타일 Y',
      'Dev C (rules 없음) → 스타일 Z',
      '→ 추가 리뷰 시간',
      '→ 증가하는 불일치',
      '→ 어려운 온보딩',
    ],
    s7_solution_t: '해결책: 4계층 공유 표준',
    s7_solution: [
      'Layer 1 — Source of Truth: team-ai-standards/ 공유 git 리포(AGENTS.md + rules/ + skills/ + templates/)',
      'Layer 2 — Gold Standard: gold-standard/examples/ (AI가 학습할 완벽한 api-handler.ts, unit.test.ts)',
      'Layer 3 — Hooks + CI로 강제: pre-commit gitleaks, PostToolUse 자동 포맷, CI lint/naming/coverage 게이트',
      'Layer 4 — Skill & Docs PR 프로세스: 모든 변경은 PR 경유, Tech Lead 리뷰, 머지 → 팀 자동 업데이트',
      'Output Consistency Checklist: 명명 · 패턴 · 에러 처리 · 커밋 규칙 · 태스크 로그 · API 계약 · ADR',
    ],

    s8_title: 'Security: Credentials & Secrets',
    s8_sub: 'Defense-in-depth — 단일 계층에 의존하지 않음',
    s8_layers: [
      { t: 'Layer 1 — 아키텍처', d: 'secrets manager 사용(AWS / Azure KV / Vault). .env.example 커밋(실제 값 없음). .env.local은 gitignore.' },
      { t: 'Layer 2 — Git', d: '.gitignore: .env .env.* *.pem *.key secrets/ credentials.json CLAUDE.local.md .claude/memory.json · pre-commit: gitleaks scan' },
      { t: 'Layer 3 — Permissions(settings.json)', d: 'deny: ["Read(./.env)","Read(./secrets/**)","Bash(curl *)","Bash(cat *.env)"]' },
      { t: 'Layer 4 — Hooks', d: 'security-hook.sh: .env / *.key / ~/.aws를 읽으려 하면 AI 차단. Exit 2 + 알림.' },
      { t: 'Layer 5 — CI/CD Gate', d: '모든 PR에 gitleaks + Trufflehog. 시크릿 패턴 감지 시 merge 차단.' },
      { t: 'Layer 6 — Rules + Training', d: 'rules/security.md: 하드코딩 금지. 항상 process.env.X 사용. AI가 sk-, api_key=, password= 자체 스캔.' },
    ],
    s8_rules_t: 'rules/security.md — AI가 따라야 할 규칙',
    s8_rules: [
      'API keys / passwords를 인라인으로 절대 작성하지 말 것 — process.env.VARIABLE_NAME 사용',
      '새 변수는 항상 .env.example에 추가(실제 값 없음), README에 문서화',
      '생성한 모든 코드를 자체 스캔: sk-, pk_, api_key=, password=, secret=, token=',
      '출력에서 시크릿 패턴 발견 시 → 중지, env var로 리팩터, 보고',
      '.env 파일 읽지 말 것 — env 구조는 docs/context/만 참조',
    ],

    s9_title: 'Input / Output Map',
    s9_sub: '모든 단계 — 누가 무엇을 하고, 무엇이 들어오고, 무엇이 나오는가',
    s9_th: ['단계', 'Human Input', 'AI가 하는 것', 'Human Gate', 'Output'],
    s9_rows: [
      ['Knowledge\nFoundation', '코드베이스\n원시 문서\n암묵지', '/init → 패턴 추출\nCLAUDE.md 초안 생성', '리뷰 + 승인\n컨텍스트 추가', 'docs/ 폴더\nCLAUDE.md v1'],
      ['Bootstrap', 'Tech stack\n규칙\n커뮤니티 리포', 'skills 커스터마이즈\ncommands + hooks 초안', 'skills 리뷰\ncommands 테스트\nhooks 승인', '.claude/skills/\n.claude/commands/\nsettings.json'],
      ['Task\nIntake', '티켓 URL 또는 브리프', 'MCP로 티켓 읽기\n확인 질문\ntask file 생성', 'task file 리뷰\n승인', 'TASK-xxx.md\ndocs/tasks/'],
      ['Design', '승인된 task file', '접근 방식 제안\nADRs와 대조\n변경할 파일 목록', '계획 승인\n또는 수정', 'Design notes\n업데이트된 task file'],
      ['Implement', '/feature TASK-xxx', 'skills + rules 로드\nTDD: 테스트 우선\n구현 + 자체 리뷰', 'diff 리뷰\nAC 수동 테스트', '소스 코드\nUnit tests\n업데이트된 태스크 로그'],
      ['Testing', '/test [file]\n/e2e [scenario]', 'test plan 생성\n승인 대기\n테스트 작성 & 실행', '시나리오 리뷰\n승인', '테스트 파일\nCoverage report'],
      ['Deploy', '/deploy [env]', 'pre-deploy 체크리스트\nstaging E2E\nSecret scan\nRelease notes', '최종 승인', 'Deploy log\nE2E 결과\nRelease notes'],
      ['Improve', '언제든지\n(버그, 패턴, 새 도구)', '반복 패턴/에러에 대한\n업데이트 제안', '리뷰 + merge\n개선', '업데이트된 CLAUDE.md\n신규/업데이트된 skills'],
    ],

    s10_title: 'Continuous Improvement Loop',
    s10_sub: '항상 활성 — 고정 스케줄 없음, 실제 이벤트로 트리거',
    s10_not_t: '이것이 아님',
    s10_not: [
      '문서 스프린트 리뷰 없음',
      '주간 업데이트 미팅 없음',
      '예약된 rules 유지보수 없음',
    ],
    s10_triggers_t: '이벤트 기반 트리거',
    s10_triggers: [
      'AI가 같은 실수를 2번 이상 반복 → 즉시 skill의 Gotchas 업데이트',
      'Dev가 같은 context를 반복 설명 → CLAUDE.md 또는 skill에 추가',
      '더 나은 패턴 발견 → skill 업데이트, 커밋, 팀 자동 수신',
      '새 도구/모델 출시 → 평가, 필요 시 workflow 업데이트',
      '버그 또는 보안 인시던트 → known-issues.md에 추가 / security rule 업데이트',
      'Tech Lead가 CLAUDE.md 담당 · Senior Dev가 특정 skills 담당 · 모든 Dev가 PR로 Gotchas 보고 · AI가 능동적으로 개선 제안',
    ],
  },
};
